/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
import React, { useEffect } from 'react';
import { get } from 'react-hook-form';
import PersonaleRuoliChiave from '../Questionario/components/PersonaleRuoliChiave';
import FinanzaCrediti from '../Questionario/components/FinanzaCrediti';
import ContinuitaIt from '../Questionario/components/ContinuitaIt';
import ProcessProdotti from '../Questionario/components/ProcessProdotti';
import LogisticaTrasporti from '../Questionario/components/LogisticaTrasporti';
import SicurezzaEPrevenzione from '../Questionario/components/SicurezzaEPrevenzione';
import MacchinariEAttrezature from '../Questionario/components/MacchinariEAttrezature';
import InfrastructureImpianti from '../Questionario/components/InfrastructureImpianti';
import StructureEdilizia from '../Questionario/components/StructureEdilizia';
import LocationAndAmbient from '../Questionario/components/LocationAndAmbient';
import GeneratingQuestionareLoader from '../../../common/components/GeneratingQuestionareLoader';
import { flagResponse } from '../../../common/constants';
import { FormInputRadio } from '../../../common/formInputsV2/FormInputRadio';
import { confirmAlert } from '../../../common/utils/alerts';

function QuestionarioDataStep({
    aiQuotestionare, loadingQuestionare, setCompleteQuestionario, completeQuestionario, errors, register, setValue,
}) {
    const handleSelectQuestionarioCompletion = (val) => {
        confirmAlert('Confermi la selezione?', () => {
            setCompleteQuestionario(val == 1);
            setValue('complete_questionario', val == 1);
        });
    };

    const errorMessages = (inputName) => (get(errors, inputName) ? get(errors, `${inputName}.message`) : null);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    if (completeQuestionario === undefined || completeQuestionario === null) {
        return (
            <div className="row mt-4">
                <FormInputRadio
                    label={'Vuoi completare il questionario? (Se completi il questionario potrai ottenere un report da scaricare con l\'analisi dei rischi della tua attività!)'}
                    options={flagResponse}
                    value={completeQuestionario}
                    onChange={(val) => handleSelectQuestionarioCompletion(val)}
                />
            </div>
        );
    }

    if (completeQuestionario === false || completeQuestionario === '0') {
        return (
            <div className="row mt-4">
                <div className="alert alert-info w-100" role="alert">
                    Hai scelto di non completare il questionario. Puoi continuare con la generazione del preventivo.
                </div>
            </div>
        );
    }

    return (
        <div className="row mt-4">
            {loadingQuestionare && completeQuestionario ? (
                <div className="mt-5 pt-5 pb-5 w-50 mx-auto rounded-lg bg-light shadow-sm">
                    <GeneratingQuestionareLoader />
                </div>
            ) : (
                <div className="container">
                    <div className="accordion" id="accordionExample">
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Localizzazione e Ambiente',
                            ) !== undefined && (
                                <LocationAndAmbient
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Struttura Edilizia',
                            ) !== undefined && (
                                <StructureEdilizia
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Infrastrutture e Impianti',
                            ) !== undefined && (
                                <InfrastructureImpianti
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Macchinari e Attrezzature',
                            ) !== undefined && (
                                <MacchinariEAttrezature
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Sicurezza e Prevenzione',
                            ) !== undefined && (
                                <SicurezzaEPrevenzione
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Logistica e Trasporti',
                            ) !== undefined && (
                                <LogisticaTrasporti
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Processi e Prodotti',
                            ) !== undefined && (
                                <ProcessProdotti
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Continuità Operativa e IT',
                            ) !== undefined && (
                                <ContinuitaIt
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Finanza e Crediti',
                            ) !== undefined && (
                                <FinanzaCrediti
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                        {aiQuotestionare.length !== 0
                            && aiQuotestionare.find(
                                (el) => el.title === 'Personale e Ruoli Chiave',
                            ) !== undefined && (
                                <PersonaleRuoliChiave
                                    errorMessages={errorMessages}
                                    register={register}
                                    errors={errors}
                                    questions={
                                        aiQuotestionare.length !== 0 && aiQuotestionare
                                    }
                                />
                            )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default QuestionarioDataStep;
